import { lazy } from 'react';

// project import
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import { Navigate } from 'react-router';
import { reactLocalStorage } from 'reactjs-localstorage';
import JastipInfo from 'pages/_configroup/jastip/JastipInfo';
import ProductList from 'pages/_configroup/po/product/ProductList';
import POInfo from 'pages/_configroup/po/POInfo';
import ProductInfo from 'pages/_configroup/po/product/ProductInfo';
import Profile from 'pages/_configroup/profile/Profile';
import ExpenseList from 'pages/_configroup/expense/ExpenseList';
import POFormMobile from 'pages/_configroup/po/POFormMobile';

// render - dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard')));
// render - pages
const Admins = Loadable(lazy(() => import('pages/_configroup/admin/AdminList')))
const AdminDetail = Loadable(lazy(() => import('pages/_configroup/admin/AdminDetail')))
const EventList = Loadable(lazy(() => import('pages/_configroup/event/EventList')))
const JastipList = Loadable(lazy(() => import('pages/_configroup/jastip/JastipList')))
const POList = Loadable(lazy(() => import('pages/_configroup/po/POList')))
const Report = Loadable(lazy(() => import('pages/_configroup/report/Report')))

// ==============================|| MAIN ROUTING ||============================== //

const isLoggedIn = reactLocalStorage.get('wb_admin_token');

// load reactlocalstorage
let getUserInfo = reactLocalStorage.get('user_info')
getUserInfo = getUserInfo ? JSON.parse(getUserInfo) : null

let SuperAdminSettings = {
  path: 'setting',
  children: [
    // {
    //   path: 'region',
    //   element: <Region />
    // },
    // {
    //   path: 'location',
    //   element: <Location />
    // },
    {
      path: 'admins',
      children: [
        {
          path: '',
          element: <Admins />
        },
        {
          path: 'add-admin',
          element: <AdminDetail />
        },
        {
          path: 'edit-admin/:id',
          element: <AdminDetail />
        }
      ]
    },
  ]
}

let WBRoutes = {
  path: '/',
  element: isLoggedIn ? <MainLayout /> : <Navigate to="/login" />,
  children: [
    {
      path: '/',
      element: <DashboardDefault />
    },
    {
      path: 'event',
      children: [
        {
          path: '',
          element: <EventList />
        },
      ]
    },
    {
      path: 'jastip',
      children: [
        {
          path: '',
          element: <JastipList />
        },
        {
          path: ':id',
          element: <JastipInfo />
        },
      ]
    },
    {
      path: 'po',
      children: [
        {
          path: '',
          element: <POList />
        },
        {
          path: ':id',
          element: <POInfo />
        },
      ]
    },
    ... (window.innerWidth < 1000) ?
    [{
      path: 'po-create',
      element: <POFormMobile />
    }] : [],
    {
      path: 'product-po',
      children: [
        {
          path: '',
          element: <ProductList />
        },
        {
          path: ':id',
          element: <ProductInfo />
        },
      ]
    },
    ... (getUserInfo && (!getUserInfo.role || getUserInfo.role == "superadmin")) ?
    [{
      path: 'report',
      children: [
        {
          path: '',
          element: <Report />
        }
      ]
    }] : [],
    ... (getUserInfo && (!getUserInfo.role || getUserInfo.role == "superadmin")) ?
    [{
      path: 'expense',
      children: [
        {
          path: '',
          element: <ExpenseList />
        }
      ]
    }] : [],
    {
      path: 'profile',
      children: [
        {
          path: '',
          element: <Profile />
        }
      ]
    },
    {
      path: "*",
      element: <Navigate to="/" />
    }
  ]
};

if (getUserInfo && (!getUserInfo.role || getUserInfo.role == "superadmin")) {
  // WBRoutes.children.unshift(PlaceRoutes)
  WBRoutes.children.push(SuperAdminSettings)
}

export default WBRoutes;
